
      if (import.meta.env.VITE_C2_VERSION !== "True") {
        document.querySelector('link[rel="icon"]').href = "/icon-small.svg"
      }
    